import { supabase } from "../lib/supabase";

function parseSkills(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }

  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

export async function syncWorkerAvailabilityRecord(worker, fallbackCity = null) {
  const availabilityWorkerId = worker?.profile_id || worker?.id || null;

  if (!availabilityWorkerId) {
    return;
  }

  const workNature = parseSkills(
    worker.skills || worker.skill || worker.nature_of_work || ""
  );

  const city =
    worker.online_city ||
    worker.go_online_city ||
    worker.city ||
    fallbackCity ||
    null;

  const currentStatus = worker.online_status || worker.availability_status || "offline";
  const isOnline =
    currentStatus === "online" &&
    Boolean(city) &&
    Boolean(worker.live_city_allowed) &&
    Boolean(worker.terms_accepted);

  const payload = {
    worker_id: availabilityWorkerId,
    city,
    is_online: isOnline,
    current_status: currentStatus,
    work_nature: workNature,
  };

  const { error } = await supabase
    .from("worker_availability")
    .upsert(payload, { onConflict: "worker_id" });

  if (error) {
    throw error;
  }
}
